import { $api } from "@/lib/api-client";

export const useCreateStatement = () => $api.useMutation("post", "/statements");
